export default __webpack_public_path__ + "static/media/registerBanner.1def38d6.png";